import { Breakpoint, useCheckBreakpoint } from '~/utils'

import CurriculumDropdown from './CurriculumDropdown'
import MenuCurriculumMobileDropdown from './MenuCurriculumMobileDropdown'

interface Props {
  handleOptionSelect: (chosenCurriculumName: string) => void
  currentCurriculum: string
  currentCurriculumCode: string
}

export default function MenuLanguageDropdown({
  handleOptionSelect,
  currentCurriculum,
  currentCurriculumCode,
}: Props): React.ReactElement {
  const isMobile = useCheckBreakpoint({ lt: Breakpoint.MD })
  if (isMobile) {
    return (
      <MenuCurriculumMobileDropdown
        currentCurriculum={currentCurriculum}
        currentCurriculumCode={currentCurriculumCode}
        handleOptionSelect={handleOptionSelect}
        isCampaignBar
      />
    )
  }
  return (
    <div className="flex flex-col items-center space-y-1 pt-3 font-medium tracking-px">
      <CurriculumDropdown
        currentCurriculum={currentCurriculum}
        currentCurriculumCode={currentCurriculumCode}
        handleOptionSelect={handleOptionSelect}
        isForMenu
      />
    </div>
  )
}
